export enum CASINO_ACTION_TYPE {
  LOSE = 1,
  WIN = 2,
  ROOLBACK = 3,
}

export enum Variant {
  COMPACT = 'compact',
  SEMI = 'semi',
  COMFORTABLE = 'comfortable',
  DEFAULT = 'default',
}

export enum Mode {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum SESSION_REUNLOCK_REASON {
  PAY_AND_PLAY_DEPOSIT_SUCCESS = 'PAY_AND_PLAY_DEPOSIT_SUCCESS',
  PAY_AND_PLAY_DEPOSIT_FAILED_AND_KYC_SUCCESS = 'PAY_AND_PLAY_DEPOSIT_FAILED_AND_KYC_SUCCESS',
}

export enum PAY_AND_PLAY_DEPOSIT_FAILED_REASON {
  PAY_AND_PLAY_DEPOSIT_FAILED = 'PAY_AND_PLAY_DEPOSIT_FAILED',
}
